export const N32 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 13,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Sales Performance by Agent",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Territory Code',
                        "columnName": 'AgentCode',
                        "width": '150px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Territory Manager Name',
                        "columnName": 'AgentName',
                        "width": '250px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    //Change the Region header to Division
                    {
                        "name": 'Division',
                        "columnName": 'RegionCode',
                        "width": '180px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Area Name',
                        "columnName": 'DistrictName',
                        "width": '250px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Territory Name',
                        "columnName": 'TerritoryName',
                        "width": '480px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Actual Sales',
                        "columnName": 'ActualSales',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target',
                        "columnName": 'TargetSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Performance %',
                        "columnName": 'Performance',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'LY Sales',
                        "columnName": 'LYSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'Growth',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    }
                ],
                "title": "AgentName",
                "endpoint": "N32",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {}
                }
            }
        }
    }
}